<template>
    <div class="module5">
        <img src="../../../assets/image/m5_img1.png" alt="示例图" />
    </div>
</template>

<style lang="scss" scoped>
.module5{
    img{
        width: 100%;
    }
}
</style>